module.exports = __webpack_public_path__ + "img/recharge_bg_disable.8e0b654b.png";